import {
  selectAttachmentReplacementNameRule,
  selectChangeMessageForFile,
} from '@UI/aside/asideFileSelector/asideFileSelectors';
import { selectAttachment } from '@newStore/documentUI/transformContent/attachmentSelectors';
import { selectNonFirstAttachmentInDownloadWarning } from '@newStore/validation/validationRules/nonFirstAttachmentDownloadWarning';
import { type BuildingBlockNodeConfig, RequiredType } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const ATTACHMENT: BuildingBlockNodeConfig = {
  nodeSelector: selectAttachment,
  information: {
    single: 'Bijlage',
    plural: 'Bijlagen',
    ribonIcon: require('../../../../img/buildingBlocks/ATTACHMENT.svg'),
  },
  validationRules: [selectNonFirstAttachmentInDownloadWarning],
  buildingBlocks: [],
  edit: [
    titleComponent,
    descriptionComponent,
    authorsComponent,
    {
      component: 'file',
      reactComponent: 'AsideFile',
      label: 'Bestand',
      definiteArticle: true,
      property: 'attachments',
      asideChangeMessageSelector: selectChangeMessageForFile,
      validations: [selectAttachmentReplacementNameRule],
      required: RequiredType.ERROR,
      options: {
        validExtensions:
          '.pdf, .jpg, .jpeg, .png, .mp3, .mp4, .doc, .docx, .dotx, .xls, .xlsx, .xltx, .ppt, .pptx, .ppsx, .potx, .tiff, .zip',
        type: 'ATTACHMENT',
      },
    },
  ],
  onNewNodeDropped: {
    openAside: true,
  },
  isCollapsible: false,
};

export default ATTACHMENT;
